// Environment for port 5314 for connection via Tunnel
export const environment = {
  production: true,
  apiURL: ''
};
